module.exports = __webpack_public_path__ + "img/skeleton-text.aa836687.svg";